/** @jsxImportSource @emotion/react */
import { faMinus, faPlus } from "@fortawesome/pro-regular-svg-icons";
import { useState } from "react";
import {
    summary_field_atron_weight, summary_field_weight
} from "../../../../../actions/Tenants/config/constants";

import useConfig from "../../../../../actions/Tenants/config/configHook";
import FruitTable from "./FruitTable";
import LegacyFruitTable from "./LegacyFruitTable";

import { Check, FruitProps, Layer } from "../../../../../actions/Layers/constants";
import { isFilledArray } from "../../../../../utils";
import { chunk } from "../../../../../utils/chunk";
import { Button } from "../../../../Helper/Button";

interface BoxedFruitTableProps {
    check: Check;
    layer: Layer;
    do_print?: boolean;
}

interface BoxItemProps {
    avocados: FruitProps[];
    check: Check;
    layer: Layer;
    title: string;
    do_print?: boolean;
}

export default function BoxedFruitTable({ check, layer, do_print = false }: BoxedFruitTableProps) {
    // take box_size from check, if unavaiable take it from layer
    const box_size = check.box_size || layer.box_size;

    const boxxes = box_size > 0 ? chunk(check.avocados, box_size) : [];

    return boxxes.map((i, index) => <BoxItem avocados={i} check={check} layer={layer} title={`Box${index + 1}`} key={index} do_print={do_print} />);
}

const parse_weight = (weight: number): string => {
    if (weight === 0 || weight > 0) {
        return `${Math.round(weight)} GRAM`;
    }
    return "-";
};

export function BoxItem({ avocados, check, layer, title, do_print = false }: BoxItemProps) {
    const config = useConfig();
    const location = config.get_check_type_config(layer, check);

    if (!location) {
        return null;
    }

    const should_show_atron_weight = location.summary_fruit_fields.some((summary_field: string) => summary_field === summary_field_atron_weight);
    const should_show_manual_weight = location.summary_fruit_fields.some((summary_field: string) => summary_field === summary_field_weight);
    const total_atron_weight = avocados.map((avocado) => avocado.atron_weight_gram ?? 0).reduce(
        (previousValue, currentValue) => previousValue + currentValue,
        0,
    );
    const total_manual_weight = avocados.map((avocado) => avocado.weight ?? 0).reduce(
        (previousValue, currentValue) => previousValue + currentValue,
        0,
    );
    const weightSelect = (): number => {
        if (should_show_atron_weight && total_atron_weight > 0) {
            return total_atron_weight;
        }
        if (should_show_manual_weight && total_manual_weight > 0) {
            return total_manual_weight;
        }

        return -1;
    };
    const [open, setOpen] = useState(!config.summary_collapsed || do_print);

    if (avocados.length === 0) {
        return null;
    }

    return <div className="mb-3 px-3 border" >
        <div className="d-flex justify-content-between align-items-center py-3">
            <h6 className="mb-0">{title}</h6>
            <div className="ms-auto"></div>
            <h6 className="mb-0 me-3">{avocados.length} items</h6>
            {(should_show_atron_weight || should_show_manual_weight) && <h6 className="mb-0 me-3">{parse_weight(weightSelect())} </h6>}
            {!do_print && <Button color="light" outline={open} onClick={() => setOpen(!open)} icon={open ? faMinus : faPlus} />}
        </div>
        {open && <div className="pb-3"><FruitTable fruits={avocados} check={check} layer={layer} do_print={do_print} /></div>}
        {open && !isFilledArray(location.summary_fruit_fields_v2) && <div className="pb-3"><LegacyFruitTable fruits={avocados} check={check} layer={layer} do_print={do_print} /></div>}
    </div>;
}
